import CardVisual from '@cohort/components-xps/components/cards/CardVisual';
import Tag from '@cohort/components-xps/components/Tag';
import i18nComponentsXpsInstance from '@cohort/components-xps/lib/i18n';
import {SvgAppIcon} from '@cohort/shared-frontend/common/AppIcons';
import {cn} from '@cohort/shared-frontend/utils/classNames';
import React from 'react';
import {getI18n, useTranslation} from 'react-i18next';

type DigitalAssetVisualProps = {
  tokenId?: number | null;
  title: string;
  blockExplorerUrl?: string | null;
  digitalAssetImageFileKey: string | null;
  animationFileKey: string | null;
  canBeObtained?: boolean;
};

export const DigitalAssetVisual: React.FC<DigitalAssetVisualProps> = ({
  tokenId,
  blockExplorerUrl,
  digitalAssetImageFileKey,
  animationFileKey,
  title,
  canBeObtained = true,
}): React.ReactElement => {
  const {t} = useTranslation('components', {
    keyPrefix: 'digitalAssetVisual',
    lng: getI18n().language,
    i18n: i18nComponentsXpsInstance,
  });

  return (
    <div className="relative">
      <div className={cn('relative', !canBeObtained && 'opacity-40 grayscale-[60%]')}>
        <CardVisual
          bannerFileKey={digitalAssetImageFileKey}
          thumbnailFileKey={null}
          videoFileKey={animationFileKey}
          visualName={title}
          trackPlayVideoClick={() => {}}
          autoPlayVideo
        />
        <div className="absolute bottom-4 right-4 flex items-center gap-2">
          {tokenId && (
            <div className="rounded-md bg-gray-200 px-2 py-1 text-xs font-medium text-slate-500">
              ID #{tokenId}
            </div>
          )}
          {blockExplorerUrl && (
            <a
              className="rounded-full border border-white"
              href={blockExplorerUrl}
              target="_blank"
              onClick={e => e.stopPropagation()}
            >
              <SvgAppIcon name="polygon" height={20} width={20} />
            </a>
          )}
        </div>
      </div>
      {!canBeObtained && (
        <Tag className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-center">
          {t('alreadyOwned')}
        </Tag>
      )}
    </div>
  );
};
